import React from 'react';
import {connect} from 'react-redux';
import {Form, actions} from 'react-redux-form';
import {Grid, Row, Col} from 'react-bootstrap';
import RequiredInput from '../../common/form/elements/required-input';
import RequiredTextarea from '../../common/form/elements/required-textarea';
import RequiredSelect from '../../common/form/elements/required-select';
import UserTitleSelector from '../../common/form/user/user-title-selector';
import ArrowButton from '../../common/button-arrow';
import {saveContact} from '../../../actions/contacts';
import ContactUsSelect from './contact-us-select';

const ContactForm = (props) => {

  const onSubmit = (payLoad) => {
    props.dispatch(actions.submitFields('deep.contact_us', saveContact(payLoad)));
  };

  return (
    <Form model="deep.contact_us"
          onSubmit={onSubmit}>
      <Grid>
        <Row>
          <Col style={{ paddingRight: '16px' }} lg={6}>
            <UserTitleSelector/>

            <RequiredInput model=".name"
                          label="Name"/>

            <ContactUsSelect model=".outlet_id"
                            values={props.outlets}
                            labelAttr={["name", "customer_number"]}
                            valueAttr="id"
                            label="Store"/>

            <RequiredInput model=".email"
                          label="Email"
                          inputType="email"/>

            <RequiredInput model=".telephone"
                          label="Telephone"/>
          </Col>

          <Col style={{ paddingLeft: '16px' }} lg={6}>
            <RequiredSelect model=".type_of_enquiry"
                            values={props.enquiries}
                            label="Type of enquiry"/>

            <RequiredTextarea model=".message"
                              label="Message"/>

            <ArrowButton arrow={false}
                        disabled={!props.formValid}
                        className="submit">Submit</ArrowButton>
          </Col>
        </Row>
      </Grid>
    </Form>
  )
};

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.contact_us.$form.valid
  };
};

export default connect(mapStateToProps)(ContactForm);



// WEBPACK FOOTER //
// ./src/components/contact-us/post-login/contact-us-form-postlogin.jsx